<template>
  <div class="news" id="news">
    <Scrollama @step-enter="stepEnterHandler">
      <div class="step1" data-step="a">
        <div class="head bg-img-maintain">
          <img :src="textData.img">
          <div class="title animation" >{{textData.title}}</div>
          <div class="content animation">{{textData.content}}</div>
<!--          <el-button class="btn animation">查看更多</el-button>-->
        </div>
      </div>
      <div class="step2" data-step="b">
          <div class="news-content" >
            <div class="animation" v-show="show1">
              <div v-for="(item, index) in dataList" :key="index">
                <div class="news-content-child" >
                  <img :src="item.img"/>
                  <div class="news-content-child-left">
                    <div class="fnt-title">
                      {{item.title}}
                    </div>
                    <div class="fnt-content" v-html="item.content">
<!--                      {{item.content}}-->
                    </div>
                    <div class="time">
                      {{item.date}}
                    </div>
                  </div>
                </div>
                <el-divider v-if="(index + 1) !== dataList.length"></el-divider>
              </div>
              <el-pagination
                @current-change="currentChange"
                style="padding: 0 0 50px"
                :page-size="pageSize"
                :current-page="pageNum"
                layout="prev, pager, next"
                :total="newList.length">
              </el-pagination>
            </div>
          </div>
      </div>
      <div class="step3" data-step="c">
        <footer-item class="animation"></footer-item>
      </div>
    </Scrollama>
  </div>
</template>
<script>
import Scrollama from 'vue-scrollama'
import footerItem from '../home/components/footer-item'
export default {
  components: {
    Scrollama,
    footerItem
  },
  data () {
    return {
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      pageSize: 5,
      pageNum: 1,
      newList: [],
      dataList: [],
      textData: {}
    }
  },
  methods: {
    stepEnterHandler ({element, index, direction}) {
      switch (element.className) {
        case 'step2':
          this.show1 = true
          break
        case 'step3':
          this.show2 = true
          break
        case 'step4':
          this.show3 = true
          break
        case 'step5':
          this.show4 = true
          break
      }
    },
    currentChange (index) {
      this.pageNum = index
      this.loadData()
      document.getElementById('news').scrollTop = 0
    },
    loadData () {
      this.dataList = this.newList.slice((this.pageNum - 1) * this.pageSize, this.pageSize * this.pageNum)
    }
  },
  created: function () {
    console.log('this.$boss', this.$boss)
    if (this.$boss) {
      this.textData = this.$boss.page411.g411[0]
      this.newList = [...this.$boss.page412.g412].map(item => {
        item.date = item.date.replace('//static.bluewisdom.com.cn/', '')
        return item
      })
      this.newList.sort((a, b) => Date.parse(b.date) - Date.parse(a.date))
      console.log('this.newList-bf', this.newList)
      this.loadData()
    }
  }
}
</script>
<style scoped lang="less">
.news{
  width: 100%;
  height: 100%;
  overflow: auto;
  div{
    //一级标题
    .first-level-title{
      font-size: 42px;
      font-weight: 500;
      color:#323232;
    }
    //背景图宽度保持不变类
    .bg-img-maintain{
      background-size: cover !important;
      background-position: center !important;
    }
    .head{
      height: 71vh;
      width: 100%;
      /*border:1px solid rgba(0, 0, 0, 0);*/
      display: flex;
      flex-direction: column;
      align-items: baseline;
      /*padding-left: 100px;*/
      /*background: url("../../static/images/news/banner.png") no-repeat;*/
      img {
        width: 100%;
        height: 100%;
      }
      .title{
        padding-left: 100px;
        font-size: 52px;
        opacity: 0;
        margin-top: -45vh;
        font-weight: 500;
        color: #fff;
      }
      .content{
        padding-left: 100px;
        font-size: 32px;
        opacity: 0;
        margin-top:40px;
        color: #E6E9F3;
      }
      .el-button {
        width: 200px;
        height: 60px;
        margin-top: 100px;
        color: #E6E9F3;
        background-color: transparent;
        border: 1px solid #E6E9F3;
        font-size: 18px;
      }
    }
    .news-content {
      min-height: 1000px;
      width: 100%;
      .el-divider {
        width: calc(100% - 200px);
        margin: 0 100px;
      }
      &-child{
        width: calc(100% - 200px);
        /*margin-left: 100px;*/
        height: 335px;
        text-align: left;
        margin: 50px 100px;
        display: flex;
        img:hover {
          transform: scale(1.05);
        }
        img {
          /*width: 562px;*/
          height: calc(100% * (2/3));
          object-fit: cover;
        }
        &-left {
          width: calc(100% - 562px);
          padding: 0 50px;
          .fnt-title {
            padding: 0;
            font-weight: bold;
            overflow:hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow:ellipsis;
          }
          .fnt-content {
            padding: 20px 0;
            line-height: 32px;
            letter-spacing: 2px;
            height: 200px;
            overflow:hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 7;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }
          .time {
            padding: 40px 0 0 0;
            font-size: 20px;
            color: #0e4798;
          }
        }
      }
      /deep/ .el-pagination button:disabled, /deep/ .el-pager li, /deep/ .el-pagination button {
        color: #8c939d;
        background: transparent;
        font-size: 24px;
      }
      /deep/ .el-pager li.active {
        color: #003f92;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/news/index.vue